import logEvent from '../logEvent';

/**
 * Logs a screen_interaction event.
 *
 * @param {string} areaName Name that represents the overall location/flow.
 * @param {string} screenType Name of screen analogous to page_type.
 * @param {Object} [rest={}] Additional properties to log.
 */
export default function logScreenInteraction(areaName, screenType, rest = {}) {
  logEvent('screen_interaction', {
    area_name: areaName,
    screen_type: screenType,
    ...rest,
  });
}
